import React, { useEffect, useState, useContext } from "react";
import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { useFormik } from "formik";
import _ from "lodash";
// Scss
import styles from "./index.module.scss";
// Component
import Text from "./../../FormControl/Text/Text";
import Select from "./../../FormControl/Select/Select";
import { AppContext } from "./../../../Context/AppContext";
import { getLocationsList } from "api/cmsLocation";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AddLocationMenu = ({
  showModal,
  pageTitle,
  menuData,
  handleSubmitClick,
  handleCancelClick,
  submitStatus,
  isEdit,
  locationParentId
}) => {
  const [showErrors, setShowErrors] = useState(false);
  const [locationList, setLocationList] = useState([]);

  const { showToastMessage } = useContext(AppContext);

  const formik = useFormik({
    initialValues: {
      title: "",
      slug: "",
      module_id: "", //location dropdown id
      status: 1,
    },
    validateOnChange: true,
    validateOnBlur: false,
    onSubmit: (values) => {
      handleSubmitClick(values);
      formik.resetForm();
      setShowErrors(false);
    },
    validate: (values) => {
      const errors = {};
        if (!values.title || values.title.trim() === "") {
        errors.title = "Please enter name";
      }
      if (!values.module_id) {
        errors.module_id = "Please select location";
      }
      return errors;
    },
  });

  // get locations list based on parent id
  const getLocationMenuList = async (data) => {
    const response = await getLocationsList(data);
    if (response && response.status === 200) {
      setLocationList(response.data.data);
      if (isEdit) {
        const locationData = response.data.data.find(
          (item) => item.id === menuData?.module_id
        );
        formik.setValues({
          ...formik.values,
          title: menuData?.title,
          module_id: locationData?.id,
          status: menuData?.status,
          slug: menuData?.slug,
        });
      }
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }
  };

  useEffect(() => {
    //Get module id present in parent data then pass it to get locations list based it's hierarchy
    //Other wise pass 0 to get all parent locations list 
    let parent_id = menuData?.module_id || 0;
    if(isEdit){
      parent_id = locationParentId;
    }
    getLocationMenuList({parent_id});
  }, []);

  const setValues = async (index, value) => {
    await formik.setValues({ ...formik.values, [index]: value });
  };

  // prepare slug based on location hierarchy
  const prepareSlug = (title) => {
    const locationParentData = locationList.find(
      (item) => item.id === formik.values.module_id
    );

    if(locationParentData?.main_parent){
      return `local/${locationParentData?.main_parent?.slug}/${locationParentData?.slug}/`;
    }else{
      return `local/${locationParentData?.slug}/`;
    }
    // if(menuData?.parent_id && menuData?.main_parent_id && menuData?.parent_id === menuData?.main_parent_id){
    //   return `local/${locationParentData?.slug}/`;
    // }else{
    //   const locationSlug = locationParentData?.main_parent ? locationParentData?.main_parent?.slug : locationParentData?.slug;
    //   return `local/${locationSlug}/${locationParentData?.slug}/`;
    // }
  };

  useEffect(() => {
    if (formik.values?.title && formik.values?.module_id) {
      formik.setValues({
        ...formik.values,
        slug: prepareSlug(formik.values?.title),
      });
    }
  }, [formik.values?.title, formik.values?.module_id]);

  return (
    <React.Fragment>
      <Dialog
        open={showModal}
        TransitionComponent={Transition}
        onClose={handleCancelClick}
        classes={{
          paper: styles.modalDialog,
        }}
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
      >
        <DialogContent className={`${styles.modalContent} px-0 py-0`}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              setShowErrors(true);
              formik.handleSubmit(e);
            }}
            onReset={(e) => {
              handleCancelClick(e);
              formik.resetForm();
            }}
          >
            <div className={`text-center ${styles.modalBody}`}>
              <h5 className={`my-3 text-center ${styles.modalTitle}`}>
                {pageTitle}
              </h5>
              <div className="row">
                <div className="col-md-6 col-xs-12">
                  <Text
                    type="text"
                    value={formik.values.title}
                    label={`Enter Menu Name`}
                    required={true}
                    submitStatus={submitStatus}
                    onChange={(data) => {
                      setValues("title", data.replace(/^\s+/, ''));
                    }}
                  />
                  {showErrors && (
                    <p className={`${styles.error} text-left`}>
                      {formik.errors.title}
                    </p>
                  )}
                </div>
                <div className="col-md-6 col-xs-12">
                  <Select
                    label={formik.values.module_id ? "Select Location" : ""}
                    placeholder={"Select Location"}
                    parentClass="text-left"
                    value={formik.values.module_id}
                    required={true}
                    submitStatus={submitStatus}
                    onChange={(data) => {
                      setValues("module_id", data);
                    }}
                    options={locationList}
                    disabled={false}
                    isCustomHeight
                    customHeight={200}
                  />
                  {showErrors && (
                    <p className={`${styles.error} text-left`}>
                      {formik.errors.module_id}
                    </p>
                  )}
                </div>
                <div className="col-md-6 col-xs-12">
                  <Select
                    label="Status"
                    parentClass="text-left"
                    value={formik.values.status}
                    required={true}
                    submitStatus={submitStatus}
                    onChange={(data) => {
                      setValues("status", data);
                    }}
                    options={[
                      { id: 0, title: "In Active" },
                      { id: 1, title: "Active" },
                    ]}
                    disabled={false}
                  />
                  {showErrors && (
                    <p className={`${styles.error} text-left`}>
                      {formik.errors.status}
                    </p>
                  )}
                </div>
                <div className="col-md-6 col-xs-12">
                  <Text
                    type="text"
                    value={formik.values.slug}
                    label={`Menu Slug`}
                    required={true}
                    submitStatus={submitStatus}
                    disabled={true}
                    onChange={(data) => {
                        setValues("slug", data);
                    }}
                  />
                  {showErrors && (
                    <p className={`${styles.error} text-left`}>
                      {formik.errors.slug}
                    </p>
                  )}
                </div>
              </div>
              <button
                type="submit"
                className="btn gray-btn d-inline-block mt-4 mb-4 mr-2"
              >
                Save
              </button>
              <button
                type="reset"
                className="btn gray-btn d-inline-block mt-4 mb-4 mr-2"
              >
                Cancel
              </button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default AddLocationMenu;
